import React, {forwardRef, useImperativeHandle, useState} from 'react';
import styled  from 'styled-components';
import Img1 from '../imgs/comfirmBg@2x.png'
const Comfirm = forwardRef((props,ref) => {
  const [visible, setVisible] = useState(false);
  function show() {
    setVisible(true);
  }
  useImperativeHandle(ref, () => ({
    show
  }));
  function close () {
    setVisible(false);
  }
  function success() {
   props.success();
    close()
  }
  return (

    <ComfirmContainer className={visible?'':'hide'}>
      <div className='bg1'>
        <div className='content'>
          <div className='title'> 只需加 <span className='money'>890元</span><br/>为你打包所有会员</div>
          <div className='tips'>
            打包所有会员将成为「风云大会员」 同时解锁所有会员
          </div>
          <div className='footer'>
            <img onClick={()=>close()} src={require('../imgs/再想想@2x.png')} alt=""/>
            <img onClick={()=> success()} src={require('../imgs/确认打包@2x.png')} alt=""/>
          </div>
        </div>
        
        <div className='close' onClick={()=>close()} >
          <img src={require('../imgs/close@2x.png')} alt=""/>
        </div>
      </div>
     
    </ComfirmContainer>
  )
})

export default Comfirm;

const ComfirmContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0, 0.82);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hide {
    display: none;
  }
 .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    line-height: 45px;
    .money {
      font-size: 44px;
      color: #ED3535;
    }
  }
  .bg1 {
    text-align: center;
    width: 89.4vw;
    height: 109vw;
    margin: auto;
    background-image: url(${Img1});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .content {
      position: absolute;
      left: 0;
      bottom: 0;
      color: black;
    }
  }
  .tips {
    margin-top:10px;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    padding:0 20px;
  }
  .content {
     width: 100%;
  }
  
  .footer {
  
   padding: 24px;
    // width: 100%;
    box-sizing: border-box;
    display:flex;
    justify-content: space-around;
    img {
      height: 40px;
      width: 50%;
      +img {
        margin-left: 24px;
      }
    }
  }
  .close {
    position: absolute;
    margin: auto;
    text-align: center;
    left: 50%;
    transform:translatex(-50%);
    bottom: -80px;
    img {
      width: 40px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_135/components/Comfirm.js